import React from 'react';

import { Form, FormikProvider, useFormik } from 'formik';

import { GradeInput, ModalHeader } from 'shared/presentation/components/atoms';
import { Button, TextArea } from 'shared/presentation/components/molecules';
import { ICONS } from 'shared/presentation/constants';
import { useLocale } from 'shared/presentation/contexts';

import { useNpsSubmission } from './hooks';
import * as S from './styles';
import { NpsFeedbackSchema } from './validations';
import { useSessionFeedback } from '../../context';

const FeedbackForm: React.FC = () => {
  const { t } = useLocale('shared');
  const controller = useNpsSubmission();

  const { session } = useSessionFeedback();

  const formik = useFormik({
    initialValues: {
      evaluation: -1,
      comment: '',
    },
    validateOnMount: true,
    validationSchema: NpsFeedbackSchema,
    onSubmit: values => {
      controller.submit(values);
    },
  });

  return (
    <FormikProvider value={formik}>
      <S.Container>
        <ModalHeader title={t('Give your feedback!')} />

        <Form>
          <p>
            {t(
              'From 1 to 10 tell us what did you think about your {{regions}} session with the applicator {{applicator}}',
              {
                regions: session.areas.join(', '),
                applicator: session.applicator.name,
              },
            )}
          </p>

          <small>
            {t('With 1 being a terrible application and 10 an excellent one')}
          </small>

          <GradeInput name="evaluation" max={10} />

          <p>
            {t(
              'Below you may leave a comment of your choice about the session',
            )}{' '}
            <small>({t('optional')})</small>
          </p>

          <TextArea
            name="comment"
            placeholder={t('Your comment here')}
            height={125}
          />

          <Button
            variant="primary"
            type="submit"
            icon={ICONS.DOUBLE_CHECK}
            iconPosition="right"
            disabled={!formik.isValid}
            loading={controller.loading}
          >
            {t('Evaluate session')}
          </Button>
        </Form>
      </S.Container>
    </FormikProvider>
  );
};

export default FeedbackForm;
